import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/formularios.css';
import '../styles/styles.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'animate.css';
import 'aos/dist/aos.css';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import logoIsc from '../components/images/logo.png';
import logoSep from '../components/images/SEP_Logo_2019.svg.png';

const ConsultaHorariosDocente = () => {
  useEffect(() => {
    const exportExcelBtn = document.getElementById('exportExcel');
    const exportPDFBtn = document.getElementById('exportPDF');

    if (exportExcelBtn) {
      exportExcelBtn.addEventListener('click', () => {
        const ws = XLSX.utils.table_to_sheet(document.querySelector('table'));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Horario');
        XLSX.writeFile(wb, 'horario.xlsx');
      });
    }

    if (exportPDFBtn) {
      exportPDFBtn.addEventListener('click', () => {
        const doc = new jsPDF();
        doc.autoTable({ html: 'table' });
        doc.save('horario.pdf');
      });
    }

    // Limpieza de listeners
    return () => {
      exportExcelBtn?.removeEventListener('click', () => {});
      exportPDFBtn?.removeEventListener('click', () => {});
    };
  }, []);

  return (
    <div className="container py-4 px-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <img src={logoIsc} alt="Logo Instituto" className="logo" />
        <div className="flex-grow-1 text-center">
          <h4 className="mb-0">Instituto Silviano Carrillo</h4>
          <small className="text-muted fs-5">Consulta de Horarios del Docente</small>
        </div>
        <img src={logoSep} alt="Logo SEP" className="logo" />
      </div>

      {/* Información del Horario */}
      <div className="p-4 bg-light rounded shadow-sm">
        <div className="schedule-info text-center">
          <div className="d-flex justify-content-center mb-3">
            <span className="font-weight-bold">MAESTRO DE EDUCACIÓN FÍSICA</span>
            <span className="mx-3"> </span>
            <span className="font-weight-bold">CLAVE: 14PR0155G</span>
          </div>
          <div className="d-flex justify-content-center mb-3">
            <span>HORARIO DE CLASES</span>
            <span className="mx-3"> </span>
            <span>AGOSTO-JULIO 2025-2026</span>
          </div>
          <div className="d-flex justify-content-center">
            <span>HORARIO DE 7:20 A 2:50</span>
          </div>
        </div>
      </div>

      {/* Tabla de horarios */}
      <div className="p-4 bg-light rounded shadow-sm">
        <h5 className="text-center">Horario de Clases - Maestro de Educación Física</h5>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Hora</th>
              <th>Lunes</th>
              <th>Martes</th>
              <th>Miércoles</th>
              <th>Jueves</th>
              <th>Viernes</th>
            </tr>
          </thead>
          <tbody id="tablaHorarios">
            <tr>
              <td>7:30 - 8:20</td>
              <td>1°A - Educación Física</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>8:30 - 9:20</td>
              <td></td>
              <td>2°A - Educación Física</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>9:30 - 10:20</td>
              <td></td>
              <td></td>
              <td>3°A - Educación Física</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>10:30 - 11:00</td>
              <td colSpan="5" className="text-center">Receso</td>
            </tr>
            <tr>
              <td>11:00 - 11:50</td>
              <td></td>
              <td></td>
              <td></td>
              <td>4°A - Educación Física</td>
              <td></td>
            </tr>
            <tr>
              <td>12:00 - 12:50</td>
              <td>6°A - Educación Física</td>
              <td></td>
              <td></td>
              <td></td>
              <td>5°A - Educación Física</td>
            </tr>
            <tr>
              <td>1:00 - 1:50</td>
              <td colSpan="5" className="text-center">Receso</td>
            </tr>
            <tr>
              <td>2:00 - 2:50</td>
              <td colSpan="5" className="text-center">Proyectos (todos los grados)</td>
            </tr>
          </tbody>
        </table>

        <div className="d-flex justify-content-between mt-4">
          <button className="btn btn-success" id="exportExcel">Exportar a Excel</button>
          <button className="btn btn-primary" id="exportPDF">Exportar a PDF</button>
        </div>
      </div>
    </div>
  );
};

export default ConsultaHorariosDocente;
